import { BudgetInformationFormFragment } from 'generated/resources/graphql'

export const getBudgetDefaultValues = (data?: BudgetInformationFormFragment | null) => {
  return {
    budgetId: data?.bugdetMovement?.budget?.id || null,
  }
}
